import React from 'react';
import { useAuthContext, useEventTrackerContext } from '../../../contexts';
import makeStyles from '@material-ui/core/styles/makeStyles';
import ContentContainer from '../../BuildingBlocks/Container/ContentContainer';
import Typography from '@material-ui/core/Typography';
import { ReactComponent as ShopifyIcon } from '../../../images/shopify.svg';
import { ReactComponent as OneIcon } from '../../../images/bullets/one.svg';
import { ReactComponent as TwoIcon } from '../../../images/bullets/two.svg';
import { ReactComponent as ThreeIcon } from '../../../images/bullets/three.svg';
import { ReactComponent as FourIcon } from '../../../images/bullets/four.svg';
import List from '@material-ui/core/List';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import { Button } from '@material-ui/core';
import PrivacyAndTermsContainer from './PrivacyAndTermsContainer';

const useStyles = makeStyles((theme: any) => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'left',
    marginBottom: theme.spacing(2),
  },
  titleContent: {
    fontWeight: 'bold',
    textAlign: 'center',
  },
  listItemIcon: {
    minWidth: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
  shopifyIcon: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  button: {
    minWidth: 175,
    fontSize: theme.fontSizes.onboarding,
    marginRight: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),
    marginBottom: theme.spacing(3),
  },
}));

const bullets = [
  {
    icon: <OneIcon />,
    text: (
      <Typography display="inline">Log into your Shopify account</Typography>
    ),
  },
  {
    icon: <TwoIcon />,
    text: (
      <Typography display="inline">
        Go to 'Settings' and select 'Users and permissions'
      </Typography>
    ),
  },
  {
    icon: <ThreeIcon />,
    text: (
      <Typography display="inline">
        Add 'Yaron Shapira' with <b>shopify@8fig.co</b>
      </Typography>
    ),
  },
  {
    icon: <FourIcon />,
    text: (
      <Typography display="inline">
        Check all the boxes under 'General' and send invite.
      </Typography>
    ),
  },
];

export default function ConnectShopifyAccount({
  goForward,
  showPrivacyAndTerms = false,
}: {
  goForward: () => void;
  showPrivacyAndTerms?: boolean;
}) {
  const classes = useStyles();
  const { firstName } = useAuthContext();
  const { trackEvent } = useEventTrackerContext();

  async function handleSubmit() {
    trackEvent({
      event: 'click_next_shopify_account',
    });
    goForward();
  }

  return (
    <ContentContainer width={600}>
      <div className={classes.content}>
        <Typography className={classes.titleContent} variant="h5">
          Hey{firstName ? ` ${firstName}` : ''}, Let’s connect your store.
        </Typography>
        <ShopifyIcon className={classes.shopifyIcon} />
        <List>
          {bullets.map((item, index) => (
            <ListItem dense={true} key={`bullet-${index}`}>
              <ListItemIcon className={classes.listItemIcon}>
                {item.icon}
              </ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItem>
          ))}
        </List>
      </div>
      <Button
        onClick={handleSubmit}
        className={classes.button}
        color="primary"
        type="submit"
        variant="contained"
        data-automation-id="ok"
      >
        OK, I Sent It
      </Button>
      {showPrivacyAndTerms && <PrivacyAndTermsContainer />}
    </ContentContainer>
  );
}
